import isApp from "shared/util/isApp";
import { isIOS } from "shared/util/EnvironmentHelpers";

export const PLATFORMS = {
	ANDROID: "ANDROID",
	IOS: "IOS",
};

// Set properties on or off for each release by platform.
const APP_FEATURES = {
	[PLATFORMS.ANDROID]: {
		"37.2.0": {
			native_landing_page: true,
		},
	},
	[PLATFORMS.IOS]: {
		"37.4.0": {
			native_landing_page: true,
		},
	},
};

const safeParseInt = (digit) => {
	const n = parseInt(digit, 10);
	// eslint-disable-next-line no-restricted-globals
	return isNaN(n) ? 0 : n;
};

// parseAppVersion accepts a version "32.1.1" and returns the digits [32, 1, 1]
// you can write shortahnd versions in APP_FEATURS like "37"
// and this function will return [37, 0, 0]
// but just write it out please
export const parseAppVersion = (version) => {
	let parts = (version || "").split(".");

	// this should never happen but just to be safe
	// make sure both versions have 3 nums to compare against
	if (parts.length > 3) {
		parts = parts.slice(0, 3);
	} else if (parts.length === 1) {
		parts = [...parts, "0", "0"];
	} else if (parts.length === 2) {
		parts = [...parts, "0"];
	}

	return parts.map(safeParseInt);
};

// copied from https://okgithub.office.okcupid.com/OkCupid/okcupid/blob/master/cupid/okcontent/lib/mobile_app.pub#L142-L185
export const isApplicableFeature = (targetVersion, featureVersion) => {
	const targetAppVersion = parseAppVersion(targetVersion);
	const featureAppVersion = parseAppVersion(featureVersion);

	return (targetAppVersion[0] > featureAppVersion[0]) ||
		!!(
			(targetAppVersion[0] === featureAppVersion[0]) &&
			(targetAppVersion[1] > featureAppVersion[1])
		) ||
		!!(
			(targetAppVersion[0] === featureAppVersion[0]) &&
			(targetAppVersion[1] === featureAppVersion[1]) &&
			(targetAppVersion[2] >= featureAppVersion[2])
		);
};

export const getFeatures = (platform, appVersion, appFeatures = APP_FEATURES) => {
	if (!appVersion || !PLATFORMS[platform]) {
		return {};
	}

	const releases = appFeatures[platform];

	return Object.keys(releases).reduce((features, featureVersion) => ({
		...features,
		...(isApplicableFeature(appVersion, featureVersion) && releases[featureVersion]),
	}), {});
};

// these functions take appFeatures arg for testing purposes, for the virtue of purity
export const getFeature = (feature, platform, version, appFeatures) =>
	getFeatures(platform, version, appFeatures)[feature];

export const getAndroidFeature = (feature, version, appFeatures) =>
	getFeature(feature, PLATFORMS.ANDROID, version, appFeatures);

export const getIOSFeature = (feature, version, appFeatures) =>
	getFeature(feature, PLATFORMS.IOS, version, appFeatures);

export const hasAppFeature = (feature) => {
	const appVersion = window.App.current_version;

	return isIOS ? getIOSFeature(feature, appVersion) : getAndroidFeature(feature, appVersion);
};


/* ADD FEATURE SPECIFIC FUNCTIONS HERE */

export const hasNativeLanding = () => isApp() && hasAppFeature("native_landing_page");




// WEBPACK FOOTER //
// ./src/shared/util/AppFeatures.js